import { notification } from "antd";

export const ShowNotification = {
  Error(messageParam: string, descriptionParam: string) {
    notification.error({
      message: messageParam,
      description: descriptionParam
    });
  },

  ErrorDefault() {
    notification.error({
      message: "Falha na consulta",
      description: "Ocorreu um erro durante a consulta. Tente novamente."
    });
  },

  Warn(messageParam: string, descriptionParam: string) {
    notification.warning({
      message: messageParam,
      description: descriptionParam
    });
  },

  Success(messageParam: string, descriptionParam: string) {
    notification.success({
      message: messageParam,
      description: descriptionParam
    });
  },

  Info(messageParam: string, descriptionParam: string) {
    notification.info({
      message: messageParam,
      description: descriptionParam
    });
  }
};
